import { render } from "./handshake-icon.vue?vue&type=template&id=184b3ab4"
import script from "./handshake-icon.vue?vue&type=script&lang=js"
export * from "./handshake-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__